import React, { ReactNode } from 'react';
import { FileFilled, GoogleOutlined, UploadOutlined } from '@ant-design/icons';
import {
  FileSource,
  OrganizationFileResponse,
} from '@server/application/files/types/file.types';
import { CellContext } from '@tanstack/react-table';
import { Tag } from 'antd';

interface SourceData {
  label: string;
  icon: ReactNode;
}

const labelsMap: Partial<Record<FileSource, SourceData>> = {
  [FileSource.LOCAL]: {
    label: 'Local Upload',
    icon: <UploadOutlined />,
  },
  [FileSource.GOOGLE_DRIVE]: {
    label: 'Google Drive',
    icon: <GoogleOutlined />,
  },
  [FileSource.CONFLUENCE]: {
    label: 'Confluence',
    icon: <FileFilled />,
  },
};

export const FileExplorerSourceColumn = <TValue,>({
  row: { original: file },
}: CellContext<OrganizationFileResponse, TValue>) => {
  if ('source' in file) {
    const { source = FileSource.LOCAL } = file || {};
    const { label, icon } = labelsMap[source] as SourceData;

    return <Tag icon={icon}>{label}</Tag>;
  }
  return null;
};
